import { createLazyImports } from '../../global/lazyLoad/lazyLoadUtils';

const componentPaths = {
    AvsModal: () => import(/* webpackChunkName: 'cmp-avsModal' */ '../components/avsModal/AvsModal'),
    PartialItemsUnavailableModal: () =>
        import(/* webpackChunkName: 'cmp-partialItemsUnavailable' */ '../components/partialItemsUnavailableModal'),
    CartDrawerGuestCheckout: () =>
        import(
            /* webpackChunkName: 'cmp-cartGuestDrawer' */ '../components/cartDrawerGuestCheckout/CartDrawerGuestCheckout'
        ),
    EmptyCartView: () =>
        import(/* webpackChunkName: 'cmp-emptyCartView' */ '../components/emptyCartView/EmptyCartView'),
    CartOrderSummary: () =>
        import(/* webpackChunkName: 'cmp-cartOrderSummary' */ '../components/cartOrderSummary/CartOrderSummary'),
    DeliverySlotAlertModal: () =>
        import(/* webpackChunkName: 'cmp-deliveryAlertModal' */ '../components/DeliverySlotAlertModal'),
    AllItemsUnavailableModal: () =>
        import(/* webpackChunkName: 'cmp-allItemsUnavailableModal' */ '../components/allItemsUnavailableModal'),
    CartItems: () => import(/* webpackChunkName: 'cmp-cartItems' */ '../components/cartItems/CartItems'),
    ChronosStoreSelectorDrawer: () =>
        import(
            /* webpackChunkName: 'cmp-chronosStoreSelectorDrawer' */ '../../global/modules/chronosStoreSelector/ChronosStoreSelectorDrawer'
        ),
    Alert: () => import(/* webpackChunkName: 'cmp-alert' */ '../../global/atoms/alert/alert'),
    AlertModalWithButtons: () => import(/* webpackChunkName: 'cmp-alertModalWithButtons' */ '../../global/atoms/AlertModalWithButtons'),
    RentalEquipmentView: () => import(/* webpackChunkName: 'cmp-rentalEquipmentView' */ '../components/rentalEquipment/RentalEquipmentView')
};

const LazyLoadCartImports = createLazyImports(componentPaths);

export const {
    AvsModal,
    PartialItemsUnavailableModal,
    CartDrawerGuestCheckout,
    EmptyCartView,
    CartOrderSummary,
    DeliverySlotAlertModal,
    AllItemsUnavailableModal,
    CartItems,
    ChronosStoreSelectorDrawer,
    Alert,
    AlertModalWithButtons,
    RentalEquipmentView
} = LazyLoadCartImports;